// Set your publishable key: remember to change this to your live publishable key in production
// See your keys here: https://dashboard.stripe.com/apikeys
//var stripe = Stripe("pk_test_51HyfKqHMpX0idUGliHjbAHHwKQIkGhplIpCyZ8zObfVVtVKpHR9z9zaDCm1WbnJZo8p5rVrDzzkqI7Kt2LQ3m9PQ00EEwFMShP"); //test env
var stripe = Stripe(
  "pk_live_51HyfKqHMpX0idUGl1uT34jzGbsOwhp6xg3DjCwtm7p7aBKYweQe7O4APhpQjxiQqiEhSKMrYAG4CExbLrfWuVW8E00hhx9g1tU"
); //live env

var elements = stripe.elements();

// Set up Stripe.js and Elements to use in checkout form
var elements = stripe.elements();
// Custom styling can be passed to options when creating an Element.
// (Note that this demo uses a wider set of styles than the guide below.)
var style = {
  base: {
    color: "#000000",
    lineHeight: "18px",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": {
      color: "#dddddd",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
  },
};
var card = elements.create("card", {
  style: style,
});
card.mount("#card-element");

card.on("change", ({ error }) => {
  let displayError = document.getElementById("card-errors");
  if (error) {
    displayError.textContent = error.message;
    document.getElementById("buyButton").disabled = true;
  } else {
    displayError.textContent = "";
    document.getElementById("buyButton").disabled = false;
  }
});

var form = document.getElementById("voucherForm");
const cardHolderName = document.getElementById("card-holder-name");
const cardButton = document.getElementById("card-button");

form.addEventListener("submit", function (ev) {
  ev.preventDefault();
  // If the client secret was rendered server-side as a data-secret attribute
  // on the <form> element, you can retrieve it here by calling `form.dataset.secret`
  //IF I Want to bill directly

  jQuery("#loading").show();

  let amount = jQuery('input[name="amount"]:checked').val();

  axios
    .post("/voucher/pay", {
      amount: amount,
      name: document.getElementById("name").value,
      email: document.getElementById("email").value,
      yemail: document.getElementById("yemail").value,
      message: document.getElementById("message").value,
      date: document.getElementById("date").value,
    })
    .then(function (response) {
      if (response.data.success == "true") {
        console.log("payment intent");

        stripe
          .confirmCardPayment(response.data.clientSecret, {
            payment_method: {
              card: card,
              billing_details: {
                name: cardHolderName,
              },
            },
          })
          .then(function (result) {
            jQuery("#loading").hide();

            if (result.error) {
              // Show error to your customer (e.g., insufficient funds)
              console.log(result.error.message);
              let displayError = document.getElementById("card-errors");
              displayError.textContent = result.error.message;
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === "succeeded") {
                console.log("success");
                console.log(result);
                let displaySuccess = document.getElementById("messagess");

                displaySuccess.textContent = "Payment has been successfull";
                displaySuccess.style.display = "block";
                let amount = jQuery('input[name="amount"]:checked').val();

                axios
                  .post("/voucher/create", {
                    amount: amount,
                    ref: response.data.clientSecret,
                    vid: response.data.vid,
                    pid: result.paymentIntent.id,
                  })
                  .then(function (response) {
                    if (response.data.success == "true")
                      window.location.replace(
                        "/voucher/" + response.data.vid + "/complete"
                      );
                  });
                // Show a success message to your customer
                // There's a risk of the customer closing the window before callback
                // execution. Set up a webhook or plugin to listen for the
                // payment_intent.succeeded event that handles any business critical
                // post-payment actions.
              }
            }
          });
      }

      //  document.getElementById('success').innerHTML='Payment data has been changed!';
      //  document.getElementById('success').classList.remove('d-none');

      if (response.data.success == "false") {
        jQuery("#loading").hide();

        console.log("payment status not changed");
        let displayError = document.getElementById("card-errors");
        displayError.textContent = response.data.message;
      }
    })
    .catch(function (error) {
      alert(error);
    });
  //  .finally(() => (AvatarTop.loading = false)) // set loading to false when request finish
});

jQuery(function () {
  jQuery('input[type="radio"]').click(function () {
    if (jQuery(this).is(":checked")) {
      document.getElementById("choosen").textContent = jQuery(this).val();
    }
  });
});

(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      // fetch all the forms we want to apply custom style
      var inputs = document.getElementsByClassName("form-control");

      // loop over each input and watch blur event
      var validation = Array.prototype.filter.call(inputs, function (input) {
        input.addEventListener(
          "blur",
          function (event) {
            // reset
            input.classList.remove("is-invalid");
            input.classList.remove("is-valid");

            if (input.checkValidity() === false) {
              input.classList.add("is-invalid");
            } else {
              input.classList.add("is-valid");
            }
          },
          false
        );
      });

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      var forms = document.getElementsByClassName("needs-validation");
      // Loop over them and prevent submission
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
            } else {
              event.preventDefault();
              event.stopPropagation();
              console.log("In here");
              //   alert('in');
              // vm.submitForm(event);
            }

            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();

/*
    Vue.component('validation-errors', {
        data() {
            return {

            }
        },
        props: ['errors'],
        template: `<div v-if="validationErrors">
                    <ul class="alert alert-danger">
                        <li v-for="(value, key, index) in validationErrors">@{{ value }}</li>
                    </ul>
                </div>`,
        computed: {
            validationErrors() {
                let errors = Object.values(this.errors);
                errors = errors.flat();
                return errors;
            }
        }
    });
    let vm = new Vue({
        el: "#contact-form",
        components: {
            'vuejs-datepicker': vuejsDatepicker,
            VueTimepicker: VueTimepicker.default

        },
        data: {
            name: '',
            email: '',
            message: '',
            validationErrors: '',
            validationSuccess: '',
            selectedTime: '00:00',
            selectedDate: moment(Date.now()).format('DD-MM-YYYY'),

        },
        methods: {
            submitForm() {

                console.log('submitting');
                console.log(card);


                axios.post('/voucher/pay', {
                    amount: 2500,
                    name: this.name,
                    email:this.email,

                })
                .then(function (response) {
                        if (response.data.success == 'true') {
                            console.log('payment intent');


                            stripe.confirmCardPayment(response.data.clientSecret, {
                                payment_method: {
                                    card: card,
                                    billing_details: {
                                        name: cardHolderName
                                    }
                                }
                            }).then(function (result) {
                                if (result.error) {
                                    // Show error to your customer (e.g., insufficient funds)
                                    console.log(result.error.message);
                                } else {
                                    // The payment has been processed!
                                    if (result.paymentIntent.status === 'succeeded') {
                                        console.log('success');
                                        console.log(result);
                                        this.validationSuccess = 'Payment has been generated and Vouched will be sent at the date and time that you selected!';

                                        // Show a success message to your customer
                                        // There's a risk of the customer closing the window before callback
                                        // execution. Set up a webhook or plugin to listen for the
                                        // payment_intent.succeeded event that handles any business critical
                                        // post-payment actions.
                                    }
                                }
                            });
                        };


                    //  document.getElementById('success').innerHTML='Payment data has been changed!';
                    //  document.getElementById('success').classList.remove('d-none');
                
                    if (response.data.success == 'false') {
                        console.log('payment status not changed');
                        document.getElementById('error').innerHTML = 'Error! Payment was not changed!';
                        document.getElementById('error').classList.remove('d-none');
                    }

            })
            .catch(function (error) {
                alert(error);

            })




                
            }
        }
    })
*/

jQuery("#datetimepicker1").datetimepicker({
  inline: true,
  sideBySide: false,
  timepicker: false,
  minDate: new Date(),

  format: "DD/MM/YYYY",

  collapse: false,
});
